const MARKDOWN_EXTENSIONS = ["md", "markdown"]

export function directoryOf(path: string): string {
  const cut = path.lastIndexOf("/")
  return cut === -1 ? "" : path.slice(0, cut)
}

export function basenameOf(path: string): string {
  return path.slice(path.lastIndexOf("/") + 1)
}

function extensionOf(path: string): string {
  const name = basenameOf(path)
  const cut = name.lastIndexOf(".")
  return cut <= 0 ? "" : name.slice(cut + 1).toLowerCase()
}

export function isMarkdownPath(path: string): boolean {
  return MARKDOWN_EXTENSIONS.includes(extensionOf(path))
}

const LANGUAGE_LABELS: Partial<Record<string, string>> = {
  py: "Python",
  js: "JavaScript",
  ts: "TypeScript",
  json: "JSON",
  yml: "YAML",
  yaml: "YAML",
  sh: "Shell",
  bash: "Shell",
  sql: "SQL",
  toml: "TOML",
  csv: "CSV",
  html: "HTML",
  css: "CSS",
  txt: "Text",
}

export function languageLabel(path: string): string | null {
  if (isMarkdownPath(path)) return null
  const extension = extensionOf(path)
  if (extension === "") return null
  return Object.hasOwn(LANGUAGE_LABELS, extension) ? LANGUAGE_LABELS[extension] ?? null : extension.toUpperCase()
}
